import styled from '@emotion/styled'

import Tabs, { useTabs } from '@segment/matcha/components/Tabs'

import CarouselCardBase, * as CarouselCard from '@segment/matcha/recipes/CarouselCard'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionTabbedBase, * as SectionTabbed from '@segment/matcha/recipes/SectionTabbed'

import SingleSourceOfTruthImage from './SingleSourceOfTruthImage'
import ExtensibleDocumentationImage from './ExtensibleDocumentationImage'
import PowerfulIntegrationsImage from './PowerfulIntegrationsImage'

const copy = {
  heading: `Create a shared data dictionary`,
  description: `Align all the teams in your company around a single data dictionary.`,
}

const tabs = [
  {
    key: `single-source-of-truth`,
    title: `A Single Source of Truth`,
    description: `Replace outdated spreadsheets with a living breathing Tracking Plan`,
    image: <SingleSourceOfTruthImage />,
  },
  {
    key: `extensible-documentation`,
    title: `Extensible Documentation`,
    description: `Give your analysts and marketers documentation so they can confidently use your data`,
    image: <ExtensibleDocumentationImage />,
  },
  {
    key: `powerful-integrations`,
    title: `Powerful Integrations`,
    description: `Reduce implementation errors with Typewriter and an extensible API`,
    image: <PowerfulIntegrationsImage />,
  },
]

const CreateSharedData = () => {
  const { activeTabKey, getTabsProps, getTabsMotionProps } = useTabs(tabs[0].key)

  return (
    <SectionComponent variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <SectionTabbedBaseStyled>
          <SectionTabbed.Copy>
            <Tabs {...getTabsProps()} mode="vertical" variant="filled">
              {tabs.map((tab) => (
                <CarouselCardBase value={tab.key} key={tab.key} active={activeTabKey === tab.key}>
                  <CarouselCardContainer alignment="left">
                    <CarouselCard.Body>
                      <CarouselCard.Title>{tab.title}</CarouselCard.Title>
                      <CarouselCard.Text>{tab.description}</CarouselCard.Text>
                    </CarouselCard.Body>
                  </CarouselCardContainer>
                </CarouselCardBase>
              ))}
            </Tabs>
          </SectionTabbed.Copy>
          {tabs.map((tab) => (
            <SectionTabbed.Media key={tab.key} {...getTabsMotionProps(tab.key)}>
              <SectionTabbed.Picture>{tab.image}</SectionTabbed.Picture>
            </SectionTabbed.Media>
          ))}
        </SectionTabbedBaseStyled>
      </Section.Contents>
    </SectionComponent>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow: hidden;
  ${Section.Wrapper} {
    padding-top: 60px;
    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-top: 120px;
    }
  }
`

const SectionTabbedBaseStyled = styled(SectionTabbedBase)`
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    gap: 0;
  }
`

const CarouselCardContainer = styled(CarouselCard.Container)`
  ${({ theme }) => theme.breakpoints.up(`xs`)} {
    row-gap: 0;
  }
`

export default CreateSharedData
